module.exports = __webpack_public_path__ + "static/img/wechat.9b75283.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/wechat.png
// module id = prkE
// module chunks = 39